import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { makeStyles } from '@material-ui/core/styles'
import colors from './colors'

const useStyles = makeStyles((theme) => ({
  applied: {
    color: colors.applied,
  },
  applying: {
    color: colors.applying,
  },
  following: {
    color: colors.following,
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(3),
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  total: {
    margin: theme.spacing(2),
    gap: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
  },
}))

const Footer = () => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Box className={classes.total}>
        <FontAwesomeIcon
          icon={faCircle}
          size="sm"
          className={classes.following}
        />
        <Typography variant="body1">Following</Typography>
      </Box>
      <Box className={classes.total}>
        <FontAwesomeIcon
          icon={faCircle}
          size="sm"
          className={classes.applying}
        />
        <Typography variant="body1">Applying</Typography>
      </Box>
      <Box className={classes.total}>
        <FontAwesomeIcon
          icon={faCircle}
          size="sm"
          className={classes.applied}
        />
        <Typography variant="body1">Applied</Typography>
      </Box>
    </Box>
  )
}

Footer.propTypes = {}

export default Footer
